<template>
    <section class="px-4 xl:px-content py-10 xl:py-20 flex md:flex-row items-center gap-6 will-change" :class="{'flex-col' : blockData.block_orientation === 'text-right', 'flex-col-reverse' : blockData.block_orientation === 'text-left'}" :data-scroll-section="inner == 'false'">

        <template v-if="blockData.block_orientation === 'text-right'">
            <!-- img -->
            <div class="md:w-1/2 relative">
                <div class="mask absolute left-0 top-0 w-10/12 h-full z-[-1] " :class="computedClass"></div>
                <div class="img-holder p-4 md:py-[9%] md:pl-[9%] md:pr-0 w-full h-auto 2xl:h-[90vh]" data-scroll data-scroll-speed="1.5" data-scroll-delay=".05">
                    <div class="overflow-hidden h-full">
                        <img class="w-full custom-easing-1" v-show="blockData.image" :src="blockData.image.sizes.imgaside" :alt="blockData.image.alt"
                        data-scroll
                        data-scroll-class="xyz-in"
                        xyz="big-25% duration-30">
                    </div>
                </div>
            </div>

            <!-- text -->
            <div class=" px-4 md:px-0 md:w-1/2 mt-8 md:mt-0">
                <div class="xl:w-8/12 xl:mx-auto" data-scroll data-scroll-class="xyz-in" xyz="fade down duration-15" >
                    <div class="tracking-desk text-xs xl:text-sm mb-5 md:mb-8 leading-5 uppercase" v-show="blockData.kicker">{{ blockData.kicker }}</div>
                    <h2 class="text-[28px] xl:text-heading mb-8 text-navy-blue-01" v-show="blockData.title">{{ blockData.title }}</h2>
                    <div class="block-text text-navy-blue-02" v-show="blockData.text" v-html="blockData.text"></div>
                    <a class="btn" v-show="blockData.cta" :href="blockData.cta.url" >{{ blockData.cta.title }}
                        <svg class="ml-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 12L21 12" stroke="#405664" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round" />
                            <path d="M18 8L22 12L18 16" stroke="#405664" stroke-width="1.2" stroke-linecap="square" />
                        </svg>
                    </a>
                </div>
            </div>

        </template>

        <template v-else>
            <!-- text -->
            <div class="px-4 md:px-0 md:w-1/2 mt-8 md:mt-0" >
                    <div class="xl:w-8/12 xl:mx-auto" data-scroll data-scroll-class="xyz-in" xyz="fade down duration-15" >
                        <div class="tracking-desk text-xs xl:text-sm mb-5 md:mb-8 leading-5 uppercase" v-show="blockData.kicker">{{ blockData.kicker }}</div>
                        <h2 class="text-[28px] xl:text-heading mb-8 text-navy-blue-01" v-show="blockData.title">{{ blockData.title }}</h2>
                        <div class="block-text text-navy-blue-02" v-show="blockData.text" v-html="blockData.text"></div>
                        <a class="btn" v-show="blockData.cta" :href="blockData.cta.url" >{{ blockData.cta.title }}
                            <svg class="ml-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 12L21 12" stroke="#405664" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round" />
                                <path d="M18 8L22 12L18 16" stroke="#405664" stroke-width="1.2" stroke-linecap="square" />
                            </svg>
                        </a>
                    </div>
            </div>

            <!-- img -->
            <div class="md:w-1/2 relative">
                <div class="mask absolute right-0 top-0 w-10/12 h-full z-[-1] " :class="computedClass"></div>
                <div class="img-holder p-4 md:py-[9%] md:pr-[9%] md:pl-0 w-full h-auto 2xl:h-[90vh]" data-scroll data-scroll-speed="1.5" data-scroll-delay=".05">
                    <div class="overflow-hidden h-full">
                        <img class="w-full custom-easing-1 will-change" v-show="blockData.image" :src="blockData.image.sizes.imgaside" :alt="blockData.image.alt"
                        data-scroll
                        data-scroll-class="xyz-in"
                        xyz="big-25% duration-30">
                    </div>
                </div>
            </div>

        </template>

    </section>
</template>


<script>
    export default {
        name: 'ImageColorBlockTextCta',
        data() {
            return {

            }
        },
        mounted() {

        },
        computed: {
            computedClass() {
                let className = 'bg-light-blue-02';
                if ( this.blockData.background_color === 'light-blue' ) {
                    className = 'bg-light-blue-02'
                }
                if ( this.blockData.background_color === 'dark-blue' ) {
                    className = 'bg-navy-blue-01'
                }
                return className;
            }
        },
        methods: {

        },
    }
</script>

<style>
  .custom-easing-1 {
    --xyz-ease: cubic-bezier(0,.83,0,1);
  }
</style>
